<template>
    <div class="sidebar" :style="{ backgroundColor: $store.state.themeColor }">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse"
            :background-color="$store.state.themeColor" text-color="#a2a2aa" active-text-color="#ffffff" unique-opened
            router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i"
                                    :index="threeItem.index">{{
        threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title
                                }}</el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
            <div class="bot" v-if="botDov">
                <!-- <div class="underLine" @click="getMenu">刷新菜单</div> -->
                <div>版权所有 © 2023 圣豆电子</div>
                <!-- <a href="https://beian.miit.gov.cn/" target="_new">备案号 XXXX-XXXX</a> -->
            </div>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
import { Getmenus } from '../../api';
export default {
    data() {
        return {
            botDov: true,
            collapse: false,
            items: [
                {
                    icon: 'el-icon-s-home',
                    index: 'project',
                    title: '项目管理'
                },

                // --------------------

                {
                    icon: 'el-icon-s-home',
                    index: 'dashboard',
                    title: '系统首页'
                },
                {
                    icon: 'el-icon-video-camera',
                    index: 'vedioMax',
                    title: '实时摄像'
                },
                {
                    icon: 'el-icon-question',
                    index: 'AlarmRecord',
                    title: '报警记录'
                },
                {
                    icon: 'el-icon-warning',
                    index: 'FaultRecord',
                    title: '故障记录'
                },
                {
                    icon: 'el-icon-s-help',
                    index: 'Device',
                    title: '设备管理'
                },
                {
                    icon: 'el-icon-user-solid',
                    index: 'User',
                    title: '用户管理'
                },
                {
                    icon: 'el-icon-s-marketing',
                    index: '5',
                    title: '绩效考核',
                    subs: [
                        {
                            index: 'PrformanceAdmin',
                            title: '管理员'
                        },
                        {
                            index: 'PrformanceUser',
                            title: '维保人员'
                        }
                    ]
                },
                {
                    icon: 'el-icon-s-custom',
                    index: 'Role',
                    title: '角色管理'
                },
                {
                    icon: 'el-icon-s-marketing',
                    index: '7',
                    title: '统计分析',
                    subs: [
                        {
                            index: 'StatisticsStatus',
                            title: '设备状态分析'
                        },
                        {
                            index: 'StatisticsAlarm',
                            title: '设备报警分析'
                        },
                        {
                            index: 'StatisticsFault',
                            title: '设备故障分析'
                        }
                    ]
                },
                {
                    icon: 'el-icon-info',
                    index: 'Notif',
                    title: '消息中心'
                }
                // {
                //     icon: 'el-icon-info',
                //     index: 'Setting',
                //     title: '系统设置'
                // },

                // {
                //     icon: 'el-icon-lx-cascades',
                //     index: 'table',
                //     title: '基础表格'
                // },
                // {
                //     icon: 'el-icon-lx-copy',
                //     index: 'tabs',
                //     title: 'tab选项卡'
                // },
                // {
                //     icon: 'el-icon-lx-calendar',
                //     index: '3',
                //     title: '表单相关',
                //     subs: [
                //         {
                //             index: 'form',
                //             title: '基本表单'
                //         },
                //         {
                //             index: '3-2',
                //             title: '三级菜单',
                //             subs: [
                //                 {
                //                     index: 'editor',
                //                     title: '富文本编辑器'
                //                 },
                //                 {
                //                     index: 'markdown',
                //                     title: 'markdown编辑器'
                //                 }
                //             ]
                //         },
                //         {
                //             index: 'upload',
                //             title: '文件上传'
                //         }
                //     ]
                // },
                // {
                //     icon: 'el-icon-lx-emoji',
                //     index: 'icon',
                //     title: '自定义图标'
                // },
                // {
                //     icon: 'el-icon-pie-chart',
                //     index: 'charts',
                //     title: 'schart图表'
                // },
                // {
                //     icon: 'el-icon-rank',
                //     index: '8',
                //     title: '拖拽组件',
                //     subs: [
                //         {
                //             index: 'drag',
                //             title: '拖拽列表'
                //         },
                //         {
                //             index: 'dialog',
                //             title: '拖拽弹框'
                //         }
                //     ]
                // },
                // {
                //     icon: 'el-icon-lx-global',
                //     index: 'i18n',
                //     title: '国际化功能'
                // },
                // {
                //     icon: 'el-icon-lx-warn',
                //     index: '7',
                //     title: '错误处理',
                //     subs: [
                //         {
                //             index: 'permission',
                //             title: '权限测试'
                //         },
                //         {
                //             index: '404',
                //             title: '404页面'
                //         }
                //     ]
                // }
                // {
                //     icon: 'el-icon-lx-redpacket_fill',
                //     index: '/donate',
                //     title: '支持作者'
                // }
            ]
        };
    },
    computed: {
        // menuArrF() {
        //     let menuData = JSON.parse(localStorage.getItem('menuData'));
        //     let arr = [
        //         {
        //             icon: 'el-icon-s-home',
        //             index: 'dashboard',
        //             title: '系统首页'
        //         }
        //     ];
        //     return arr.concat(menuData)
        // },
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    methods: {
        // async getMenu() {
        //     // 获取折叠菜单
        //     const GetmenusResult = await Getmenus();
        //     if (GetmenusResult.status !== 1) {
        //         // 获取折叠菜单失败
        //         this.$message.error('获取菜单错误');
        //         return;
        //     }
        //     let menuArr = [];
        //     // 格式化一级菜单
        //     GetmenusResult.message.forEach((item, index) => {
        //         if (item.parentId == 0) {
        //             let obj = {
        //                 icon: item.icon,
        //                 index: item.menuPath,
        //                 title: item.menuDisplayName,
        //                 menuID: item.menuID,
        //                 parentId: item.parentId,
        //                 menuName: item.menuName,
        //                 sortNumber: item.sortNumber,
        //                 status: item.status
        //             };
        //             menuArr.push(obj);
        //         }
        //     });
        //     // 格式化二级菜单
        //     GetmenusResult.message.forEach((item, index) => {
        //         menuArr.forEach((it, ind) => {
        //             if (item.parentId !== 0) {
        //                 // 存在父级菜单
        //                 if (item.parentId == it.menuID) {
        //                     // 判断是否已存在父级子菜单
        //                     if (it.subs) {
        //                         let obj = {
        //                             index: item.menuPath,
        //                             title: item.menuDisplayName,
        //                             menuID: item.menuID,
        //                             parentId: item.parentId,
        //                             menuName: item.menuName,
        //                             sortNumber: item.sortNumber,
        //                             status: item.status
        //                         };
        //                         menuArr[ind].subs.push(obj);
        //                     } else {
        //                         it.subs = [];
        //                         menuArr[ind].subs = [
        //                             {
        //                                 index: item.menuPath,
        //                                 title: item.menuDisplayName,
        //                                 menuID: item.menuID,
        //                                 parentId: item.parentId,
        //                                 menuName: item.menuName,
        //                                 sortNumber: item.sortNumber,
        //                                 status: item.status
        //                             }
        //                         ];
        //                     }
        //                 }
        //             }
        //         });
        //     });
        //     console.log('获取成功');
        //     console.log(menuArr);
        //     const arr = menuArr.sort((a, b) => {
        //         let val1 = a.sortNumber;
        //         let val2 = b.sortNumber;
        //         return val1 - val2;
        //     });
        //     console.log(arr);
        //     localStorage.setItem('menuData', JSON.stringify(arr));
        // }
    },
    created() {
        const companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
        if (companyInfo.companyRole === '0') {
            // 圣豆电子 拥有全部权限
            this.items = [
                {
                    icon: 'iconfont icon-shouye',
                    index: 'ADashboard',
                    title: '首页'
                },
                {
                    icon: 'iconfont icon-qiye',
                    index: 'ACompany',
                    title: '企业管理'
                },
                {
                    icon: 'iconfont icon-xiangmuluyan',
                    index: 'AProject',
                    title: '项目管理'
                },
                {
                    icon: 'iconfont icon--shebei',
                    index: 'ADevice',
                    title: '设备管理'
                },
                {
                    icon: 'iconfont icon-baogaogongdan',
                    index: 'ATask',
                    title: '工单中心'
                },

                {
                    icon: 'iconfont icon-yonghu',
                    // index: 'AUser',
                    title: '用户管理',
                    subs: [
                        {
                            index: 'AUser',
                            title: '管理员'
                        },
                        {
                            index: 'AMaintainUser',
                            title: '维保人员'
                        }
                    ]
                },
                // {
                //     icon: 'iconfont icon-shezhi',
                //     index: 'Asystem',
                //     title: '系统设置'
                // }
            ];
        } else {
            this.items = [
                {
                    icon: 'iconfont icon-shouye',
                    index: 'ADashboard',
                    title: '首页'
                },
                {
                    icon: 'iconfont icon--shebei',
                    index: 'ADevice',
                    title: '设备管理'
                },
                {
                    icon: 'iconfont icon-baogaogongdan',
                    index: 'ATask',
                    title: '工单中心'
                },
                {
                    icon: 'iconfont icon-yonghu',
                    title: '用户管理',
                    subs: [
                        {
                            index: 'AMaintainUser',
                            title: '维保人员'
                        }
                    ]
                },
                // {
                //     icon: 'iconfont icon-shezhi',
                //     index: 'Asystem',
                //     title: '系统设置'
                // }
            ];
        }

        // console.log('this.$store.slideMenu');
        // console.log(this.$store.state.slideMenu);

        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
            if (msg) {
                this.botDov = false;
            } else {
                this.botDov = true;
            }
        });
    }
};
</script>

<style scoped lang="less">
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}

.sidebar>ul {
    height: 100%;
}

.bot {
    position: absolute;
    bottom: 10px;
    font-size: 0.2rem;
    color: #ccc;
    width: 100%;
    text-align: center;

    a {
        font-size: 0.2rem;
        color: #ccc;
    }
}

.underLine:hover {
    text-decoration: underline;
    cursor: pointer;
    color: #66b1ff;
}

.iconfont {
    margin-right: 10px;
    color: #a2a2aa;
}
</style>
